import { FETCH_CONSULTATION ,FETCH_PATIENTS_CONSULTATION_DETAILS} from "./type";
import loginedApi from "../apis";
import CryptoJS from "crypto-js";
import { FETCH_VISIT_HISTORY } from "../actions/type";

  var hashcode = CryptoJS.SHA256(process.env.REACT_APP_PREFIX+process.env.REACT_APP_TOKEN+process.env.REACT_APP_SECRETKEY);

const { detect } = require('detect-browser');
const browser = detect();

let off = new Date().toString().replace(/GMT\+(\d\d)(\d\d)/, "GMT+$1:$2");
let formatTime = off?.split("GMT")[1].split(" (")[0];
let result = formatTime?.slice(1);
if (formatTime.search(/\+/g) != null) {
  formatTime = formatTime.replace(/\+/g, "%2B")
} else if (formatTime.search(/\-/g) != null) {
  formatTime = formatTime.replace(/\-/g, "%2D")
}//replace(/\+/g,' ') browserTimeZone: `GMT${formatTime}`

// export const fetchVisitHistory = (patientId) => async (dispatch) => {
//   try {
//     const params = {
//       token: hashcode.toString(),
//       data: {
//         patientId: patientId,
//       },
//     };

//     const response = await loginedApi.post("getvisithistory", params);

//     if (response.status === 200 && response.data.status === "success") {
//       dispatch({ type: FETCH_VISIT_HISTORY, payload: response.data.output });
//     } else {
//       console.error("Failed to fetch visit history:", response.data.message);
//       dispatch({ type: FETCH_VISIT_HISTORY, payload: [] });

//     }
//   } catch (error) {
//     console.error("Error in fetchVisitHistory action:", error);
//     dispatch({ type: FETCH_VISIT_HISTORY, payload: [] });

//   }
// };

export const fetchVisitHistory = (patientId) =>  async (dispatch) => {

  let res = await loginedApi.post("getvisithistory", {
      token : "fcfb70e15b304a88af137f8a0906e65c0bc7f1d662e6aed146f34c0e975d6756",
      data: {
          patientId:patientId
      },
      // requestType: 1900
  });
  console.log(res);
  return res.data.data;
};

export const fetch_clientDetails = (consultationId, userType) => async (dispatch) => {



  let countrycoderes = await loginedApi.post("getcountrycode",
    {
      token :hashcode.toString(),
      "version": "2.0",
      "data": { browserTimeZone: `GMT${formatTime}`, },
      "requestType": 1058
    });

  let doctorscountrycode = countrycoderes.data.data;
  let params = {
    requestType: "400",
   token :hashcode.toString(),
    data: {
      browserTimeZone: `GMT${formatTime}`,
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,
      Ipaddress: doctorscountrycode.Ipaddress,
      todayRate: "",
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      consultationId: consultationId,
      userType: userType,
    },
  };


  if (consultationId != "") {
    params.data.consultationId = consultationId;
  }

  console.log("Calling............................", params);
  const response = await loginedApi.post("consultation", params);
  dispatch({ type: FETCH_CONSULTATION, payload: response.data.data });

  return response.data.data;
};

export const fetch_ConsultationDetails = (consultationId, userType) => async (dispatch) => {
  let countrycoderes = await loginedApi.post("getcountrycode",
    {
      token :hashcode.toString(),
      "version": "2.0",
      "data": { browserTimeZone: `GMT${formatTime}`, },
      "requestType": 1058
    });

  let doctorscountrycode = countrycoderes.data.data;
  let params = {
    requestType: "404",
   token :hashcode.toString(),
    data: {
      browserTimeZone: `GMT${formatTime}`,
      currency: doctorscountrycode.currency,
      accessCountry: doctorscountrycode.Country,
      Ipaddress: doctorscountrycode.Ipaddress,
      todayRate: "",
      Browser: browser.name + " " + browser.version,
      appname: "C2MD Web",
      consultationId: consultationId,
      userType: userType,
    },
  };

  if (consultationId != "") {
    params.data.consultationId = consultationId;
  }

  const response = await loginedApi.post("consultation", params);
  dispatch({ type: FETCH_PATIENTS_CONSULTATION_DETAILS, payload: response.data.data });

  return response.data.data;
};

export const finishconsultation = (prescriptiondetails) => async (dispatch) => {
  console.log("Inside fetchlistofpatientsvitals")   

  let data = {
    prescriptionDetails: prescriptiondetails,
    browserTimeZone: `GMT${formatTime}`

}

  
 const response = await loginedApi.post("consultation", {
    requestType : 205,
   token :hashcode.toString(),
    data,
   "version":"2.0",
  }
    
  );
  
  console.log( "fetchlistofpatientsvitals API - Response!!!" ,response);
   if (response.status === 200) {
    
    // dispatch({ type: FETCH_PATIENTS_CONSULTATION_HISTORY, payload: response.data });
    return response.data
   }  
};

export const screenstatusupdate = (userType,appointmentId,status) => async (dispatch) => {
  console.log("Inside fetchlistofpatientsvitals")   

 
  
 const response = await loginedApi.post("consultation", {
    requestType : 225,
   token :hashcode.toString(),
   data: {
    browserTimeZone: `GMT${formatTime}`,
    todayRate: "",
    Browser: browser.name + " " + browser.version,
    appname: "C2MD Web",
    Status:status,
    appointmentId: appointmentId,
    userType: userType,
  },
   "version":"2.0",
  }
    
  );
  
  console.log( "fetchlistofpatientsvitals API - Response!!!" ,response);
   if (response.status === 200) {
    
    // dispatch({ type: FETCH_PATIENTS_CONSULTATION_HISTORY, payload: response.data });
    return response.data
   }  
};


export const consultationfeedback = (appointmentId,feedback,comments) => async (dispatch) => {
  console.log("Inside consultationfeedback",appointmentId,feedback,comments  )   
  let doctorRating = {
    consultationId: appointmentId,
    reviewRating: feedback,
    comments:comments

}
 const response = await loginedApi.post("consultation", {
    requestType : 207,
   token :hashcode.toString(),
   data: {
    browserTimeZone: `GMT${formatTime}`,
    todayRate: "",
    Browser: browser.name + " " + browser.version,
    appname: "C2MD Web",
    doctorRating:doctorRating,
    
  },
   "version":"2.0",
  }
    
  );
  
  console.log( "fetchlistofpatientsvitals API - Response!!!" ,response);
   if (response.status === 200) {
    
    // dispatch({ type: FETCH_PATIENTS_CONSULTATION_HISTORY, payload: response.data });
    return response.data
   }  
};